<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7HMGz1/tc-custom/9780253011879.jpg?1737751530637" alt="This image is the cover for the book Louisville, Cincinnati & Charleston Rail Road, Railroads Past and Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Louisville, Cincinnati & Charleston Rail Road, Railroads Past and Present
      </h1>
      <p class="bookDescription body article font2">
        <p>Among the grand antebellum plans to build railroads to interconnect the vast American republic, perhaps none was more ambitious than the Louisville, Cincinnati &amp; Charleston. The route was intended to link the cotton-producing South and the grain and livestock growers of the Old Northwest with traders and markets in the East, creating economic opportunities along its 700-mile length. But then came the Panic of 1837, and the project came to a halt. H. Roger Grant tells the incredible story of this singular example of "railroad fever" and the remarkable visionaries whose hopes for connecting North and South would require more than half a century—and one Civil War—to reach fruition.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Roger Grant
      </h2>
      
      <p class="authorDescription body article"><P>H. Roger Grant is Kathryn and Calhoun Lemon Professor of History at Clemson University. He is author of 30 books, including Visionary Railroader (IUP, 2008), Iowa's Railroads (with Don L. Hofsommer) (IUP, 2009), and Railroads and the American People (IUP, 2012).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f65209f